<template>
  <Form
    ref="formRef"
    :rules="ruleValidate"
    :model="formData"
    label-position="top"
  >
    <FormItem label="接口名称" key="portName" prop="portName">
      <!-- <Input v-model="formData.portName" placeholder="请输入" /> -->
      <Select v-model="formData.portName">
        <Option
          v-for="(item, key) in portNames"
          :value="item"
          :key="key"
          >{{ item }}</Option
        >
      </Select>
    </FormItem>
    <FormItem label="波特率" key="parameter1" prop="parameter1">
      <Input v-model="formData.parameter1" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem label="数据位" key="parameter2" prop="parameter2">
      <Select v-model="formData.parameter2">
        <Option v-for="(item, key) in parameter2s" :value="item" :key="key">{{
          item
        }}</Option>
      </Select>
    </FormItem>
    <FormItem label="奇偶校检位" key="parameter3" prop="parameter3">
      <Select v-model="formData.parameter3">
        <Option v-for="(item, key) in parameter3s" :value="item" :key="key">{{
          item
        }}</Option>
      </Select>
    </FormItem>
    <FormItem label="停止位" key="parameter4" prop="parameter4">
      <Select v-model="formData.parameter4">
        <Option v-for="(item, key) in parameter4s" :value="item" :key="key">{{
          item
        }}</Option>
      </Select>
    </FormItem>
    <FormItem label="设备号" key="parameter5" prop="parameter5">
      <Input v-model="formData.parameter5" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem label="最大读写寄存器数" key="parameter6" prop="parameter6">
      <Input v-model="formData.parameter6" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="采集周期（毫秒）"
      key="interval"
      prop="interval"
    >
      <Input v-model="formData.interval" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="轮询延时（毫秒)"
      key="pollsDelay"
      prop="pollsDelay"
    >
      <Input v-model="formData.pollsDelay" type="number" placeholder="请输入" />
    </FormItem>
    <FormItem
      label="响应超时（毫秒)"
      key="responseTimeout"
      prop="responseTimeout"
    >
      <Input v-model="formData.responseTimeout" type="number" placeholder="请输入" />
    </FormItem>
  </form>
</template>

<script>
const staticParameterList = [
  'portName',
  'parameter1',
  'parameter2',
  'parameter3',
  'parameter4',
  'parameter5',
  'parameter6',
  'interval',
  'pollsDelay',
  'responseTimeout',
];
export default {
  name: 'FormRTU',
  props: {
    defaultFormData: {
      type: Object,
      default: () => null,
    },
  },
  watch: {
    defaultFormData: function (newValue) {
      if (newValue) {
        staticParameterList.forEach((option) => {
          if (option === 'interval') {
            this.formData[option] = newValue[option] || 1000;
          } else if (option === 'pollsDelay') {
            this.formData[option] = newValue[option] || 100;
          } else if (option === 'parameter2') {
            this.formData[option] = newValue[option] || 8;
          } else if (option === 'portName') {
            this.formData[option] = newValue[option] || this.portNames[0];
          } else if (option === 'parameter4') {
            this.formData[option] = newValue[option] || 1;
          } else if (option === 'parameter3') {
            this.formData[option] = newValue[option] || 'N';
          } else if (option === 'parameter6') {
            this.formData[option] = newValue[option] || '125';
          } else if (option === 'responseTimeout') {
            this.formData[option] = newValue[option] || '500';
          } else {
            this.formData[option] = newValue[option];
          }
        });
      }
    },
  },
  data: function () {
    return {
      formData: {
        portName: '',
        parameter1: '',
        parameter2: '',
        parameter3: '',
        parameter4: '',
        parameter5: '',
        parameter6: '',
        interval: '',
        pollsDelay: '',
        responseTimeout: '',
      },
      portNames: ["/dev/ttyS4"],
      parameter2s: [5, 6, 7, 8],
      parameter4s: [1, 2],
      parameter3s: ["N", "E", "O"],
      ruleValidate: {
        portName: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.portName;
              if (!value1) {
                callback(new Error("请输入接口名称"));
              } else if (!/\/\s*[a-zA-Z0-9]+/.test(value1)) {
                callback(new Error('请正确输入接口名称'));
              }
              callback();
            },
          },
        ],
        parameter1: [
          {
            required: true,

            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter1;

              if (!value1) {
                callback(new Error("请填写波特率"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写波特率'));
              }
              callback();
            },
          },
        ],
        parameter2: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter2;
              if (!value1) {
                callback(new Error("请选择数据位"));
              }
              callback();
            },
          },
        ],
        parameter4: [
          {
            required: true,

            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter4;
              if (!value1) {
                callback(new Error("请选择停止位"));
              }
              callback();
            },
          },
        ],
        parameter3: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter3;
              if (!value1) {
                callback(new Error("请选择奇偶校检位"));
              }
              callback();
            },
          },
        ],
        parameter5: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter5;

              if (!value1) {
                callback(new Error("请填写设备号"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写设备号'));
              }
              callback();
            },
          },
        ],
        parameter6: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.parameter6;

              if (!value1) {
                callback(new Error("请填写最大读写寄存器数"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写最大读写寄存器数'));
              }
              callback();
            },
          },
        ],
        interval: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.interval;
              if (!value1) {
                callback(new Error("请填写采集周期"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写采集周期'));
              }
              callback();
            },
          },
        ],
        pollsDelay: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.pollsDelay;

              if (!value1) {
                callback(new Error("请填写轮询延时"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写轮询延时'));
              }
              callback();
            },
          },
        ],
        responseTimeout: [
          {
            required: true,
            trigger: "blur,change",
            validator: (rule, value, callback) => {
              let value1 = this.formData.responseTimeout;

              if (!value1) {
                callback(new Error("请填写响应超时时间"));
              } else if (parseInt(value1) <= 0) {
                callback(new Error('请正确填写响应超时时间'));
              }
              callback();
            },
          },
        ],
      },
    };
  },
  methods: {
    resetFields: function () {
      this.$refs.formRef.resetFields();
    },
    validate: function (callback) {
      this.$refs.formRef.validate((valid) => {
        callback(valid, this.formData);
      });
    },
  },
};
</script>

<style></style>
